import {
  formEditTopic,
  snackbarSummaryTopicUpdatedSuccessSubTitlePart1,
  snackbarSummaryTopicUpdatedSuccessSubTitlePart2,
  snackbarSummaryTopicUpdatedSuccessTitle,
  buttonSaveUpdate,
  modalEditTopicSubTitle,
  modalEditTopicTitle,
} from "_constants";
import { FormAddTopic } from "components/form/FormAddTopic";
import {
  SingleStepBody,
  SingleStepDialog,
  SingleStepFooter,
  SingleStepHeaders,
} from "components/SingleStepDialog";
import { useConfirmDialogExit } from "hooks";
import { Topic } from "interfaces";
import { useSnackbar } from "providers/SnackbarProvider";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { updateTopic } from "services";
import { setNameTopicValidation } from "store/slicer/FormTopicValidationSlice";
import { setPageTopics } from "store/slicer/GestioneTopicsSlice";
import { useAppDispatch } from "store/store";

export const ModalEditTopic = ({
  showModal,
  topic,
  closeModalEditTopicCallback,
}: {
  showModal: boolean;
  topic: Topic;
  closeModalEditTopicCallback: Function;
}) => {
  const dispatch = useAppDispatch();
  const { showSnackbar } = useSnackbar();
  const { showConfirmDialogExit } = useConfirmDialogExit();

  const { handleSubmit, control, trigger, getValues } = useForm({
    defaultValues: {
      id: topic?.id,
      name: topic?.name,
      description: topic?.description,
    },
    shouldFocusError: false,
    mode: "onChange",
  });

  useEffect(() => {
    control._reset({
      id: topic?.id,
      name: topic?.name,
      description: topic?.description,
    });
  }, [topic, control]);

  const onSubmit = (formData: any) => {
    updateTopic(formData)
      .then((_) => {
        showSnackbar({
          severity: "success",
          summary: snackbarSummaryTopicUpdatedSuccessTitle,
          detail: `${snackbarSummaryTopicUpdatedSuccessSubTitlePart1}${getValues(
            "name"
          )}${snackbarSummaryTopicUpdatedSuccessSubTitlePart2}`,
          life: 5000,
        });
        dispatch(setPageTopics(-1));
        setTimeout(() => {
          dispatch(setPageTopics(1));
        }, 200);
        resetFormState();
      })
      .catch((error) => {
        if (error?.response?.status === 409) {
          dispatch(setNameTopicValidation(false));
        }
      });
  };

  const handleDismiss = () => {
    if (control._getDirty()) {
      showConfirmDialogExit({ rejectCallback: resetFormState });
    } else {
      resetFormState();
    }
  };

  const resetFormState = () => {
    closeModalEditTopicCallback();
    control._reset();
  };

  return (
    <SingleStepDialog
      onHideCallback={handleDismiss}
      height="369px"
      width="700px"
      header={
        <SingleStepHeaders
          title={modalEditTopicTitle}
          subtitle={modalEditTopicSubTitle}
        />
      }
      body={
        <SingleStepBody
          content={
            <form
              id={formEditTopic}
              onSubmit={handleSubmit(onSubmit)}
              className="width-100 padd-top-4"
            >
              <FormAddTopic control={control} trigger={trigger} />
            </form>
          }
        />
      }
      footer={
        <SingleStepFooter
          dismiss={handleDismiss}
          form={formEditTopic}
          labelSubmit={buttonSaveUpdate}
        />
      }
      display={showModal}
      setVisible={() => {}}
    />
  );
};
